import React from 'react';
import {
  HeaderTitle,
  HeaderDescription,
  SmallHeaderTitle,
} from './PageHeader.styled';

type HeaderProps = {
  title: string;
  showDescription?: boolean;
  testId?: string;
  useResponsiveSizes?: boolean;
  titleLevel?: 'h1' | 'h4';
};

export const PageHeader = (props: HeaderProps) => {
  const {
    title,
    showDescription,
    testId,
    useResponsiveSizes,
    titleLevel = 'h1',
  } = props;
  return (
    <>
      {titleLevel === 'h4' ? (
        <SmallHeaderTitle data-testid={testId}>{title}</SmallHeaderTitle>
      ) : (
        <HeaderTitle
          data-testid={testId}
          useResponsiveSizes={useResponsiveSizes}
        >
          {title}
        </HeaderTitle>
      )}
      {showDescription && (
        <HeaderDescription>
          A supercharged add-on for your OVO Energy plan
        </HeaderDescription>
      )}
    </>
  );
};

PageHeader.defaultProps = {
  showDescription: true,
};
